module.exports = __webpack_public_path__ + "img/book_mark.fa0b9c75.svg";